import { FC } from 'react'

import BorderLeftIcon from '@mui/icons-material/BorderLeft'
import BorderRightIcon from '@mui/icons-material/BorderRight'
import CloseIcon from '@mui/icons-material/Close'
import { Button, FormControlLabel, IconButton, Stack, Switch } from '@mui/material'
import { useTheme } from '@mui/material'
import { DrawerPosition, useHistoricalStatisticsStore } from '@/stores/historicalStatistics'

import { CONTROLS_HEIGHT } from './FiltersDrawer'

export const TEST_IDS = {
  leftPositionButton: 'left-position-button',
  rightPositionButton: 'right-position-button',
  closeButton: 'close-button',
  h2hSwitch: 'h2h-switch'
} as const

const PositionControls = () => {
  const theme = useTheme()
  const { drawerPosition, setDrawerPosition } = useHistoricalStatisticsStore()

  const isSelectedPosition = (position: DrawerPosition) => {
    return drawerPosition === position
  }

  return (
    <Stack direction="row">
      <IconButton
        data-testid={TEST_IDS.leftPositionButton}
        onClick={() => {
          setDrawerPosition('left')
        }}
      >
        <BorderLeftIcon
          sx={{
            cursor: 'pointer',
            color: isSelectedPosition('left') ? theme.palette.primary.main : theme.palette.grey[500]
          }}
        />
      </IconButton>
      <IconButton
        data-testid={TEST_IDS.rightPositionButton}
        onClick={() => {
          setDrawerPosition('right')
        }}
      >
        <BorderRightIcon
          sx={{
            cursor: 'pointer',
            color: isSelectedPosition('right')
              ? theme.palette.primary.main
              : theme.palette.grey[500]
          }}
        />
      </IconButton>
    </Stack>
  )
}

type Props = {
  onClose: () => void
  onClear: () => void
  onReset?: () => void
  resetDisabled?: boolean
}

export const FiltersDrawerTopControls: FC<Props> = ({
  onClose,
  onClear,
  onReset,
  resetDisabled = false
}) => {
  const theme = useTheme()
  const { isH2H, setIsH2H } = useHistoricalStatisticsStore()

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        height={CONTROLS_HEIGHT}
        p={1}
        pb={1}
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid ${theme.palette.divider}`
        }}
      >
        <Stack direction="row">
          <PositionControls />
          <FormControlLabel
            sx={{ ml: 1 }}
            control={<Switch checked={isH2H} onChange={() => setIsH2H(!isH2H)} size="small" />}
            label="H2H"
          />
        </Stack>
        <Stack direction="row" alignItems="center" gap={1}>
          {onReset && (
            <Button variant="text" onClick={onReset} disabled={resetDisabled}>
              Reset
            </Button>
          )}
          <Button variant="text" onClick={onClear}>
            Clear all
          </Button>
          <IconButton data-testid={TEST_IDS.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </Stack>
    </>
  )
}
